import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

import { SimpleForm } from '../../../components/panel/panel';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';

import {
  getVersionApp,
  updateApkClientName,
  getApkDownloadQr,
} from '../../../app/store/actions/settings';
import { addLoading, removeLoading } from '../../../app/store/actions/loading';
import ApkService from '../../../app/server/apk';
import ServerUtils from '../../../data/server';
import ApkDownloadQrCode from '../../../components/utils/ApkDownloadQrCode';

class DevelopDownloadApk extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      versionApp: '',
      apkClientName: '',
      apkClientNameOriginal: '',
      apkClientNameEditing: false,
      apkDownloadUrl: '',
    };
  }

  componentDidMount() {
    this.loadPageInfo();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.userLogged && this.props.userLogged) {
      this.loadPageInfo();
    }
  }

  loadPageInfo = async () => {
    this.props.addLoading();
    try {
      const versionData = await this.props.getVersionApp();

      const apkClientName = (versionData && versionData.apkClientName) || '';
      this.setState({
        apkClientName,
        apkClientNameOriginal: apkClientName,
        versionApp: (versionData && versionData.versionApp) || '',
        apkClientNameEditing: false,
      });

      if (apkClientName) {
        await this.loadApkDownloadQr();
      } else {
        this.setState({ apkDownloadUrl: '' });
      }
    } catch (e) {
      addNotification(
        'danger',
        I18n.t('BEE4667' /* Download APK */),
        I18n.t('BEE1969' /* Erro ao buscar dados */),
        'top-right',
      );
    } finally {
      this.props.removeLoading();
    }
  };

  loadApkDownloadQr = async () => {
    try {
      const qrData = await this.props.getApkDownloadQr();
      const token = (qrData && qrData.token) || '';

      if (!token) {
        this.setState({ apkDownloadUrl: '' });
        return;
      }

      const baseUrl = ServerUtils.getBaseUrl();
      const apkDownloadUrl = `${baseUrl}settings/apkDownloadByToken?token=${encodeURIComponent(token)}`;
      this.setState({ apkDownloadUrl });
    } catch (e) {
      this.setState({ apkDownloadUrl: '' });
    }
  };

  updateApkClientName = async () => {
    const { apkClientName } = this.state;
    try {
      await this.props.updateApkClientName(apkClientName);
      addNotification(
        'success',
        I18n.t('BEE4667' /* Download APK */),
        I18n.t('BEE4673' /* Identificador do Cliente (APK) atualizado com sucesso */),
        'top-right',
      );
      return true;
    } catch (e) {
      addNotification(
        'danger',
        I18n.t('BEE4667' /* Download APK */),
        I18n.t('BEE4674' /* Erro ao atualizar o Identificador do Cliente (APK) */),
        'top-right',
      );
      return false;
    }
  };

  saveApkClientNameEditing = async () => {
    const saved = await this.updateApkClientName();
    if (saved) {
      this.setState((prevState) => ({
        apkClientNameEditing: false,
        apkClientNameOriginal: prevState.apkClientName,
      }));
      if (this.state.apkClientName) {
        await this.loadApkDownloadQr();
      } else {
        this.setState({ apkDownloadUrl: '' });
      }
    }
  };

  handleDownload = async () => {
    const { apkClientName } = this.state;

    if (!apkClientName) {
      addNotification(
        'warning',
        I18n.t('BEE4667' /* Download APK */),
        I18n.t('BEE4676' /* Configure o Identificador do Cliente (APK). */),
        'top-right',
      );
      return;
    }

    this.props.addLoading();
    try {
      const response = await ApkService.downloadLatestApk();
      if (response.success) {
        addNotification(
          'success',
          I18n.t('BEE4667' /* Download APK */),
          I18n.t('BEE4670' /* Download do APK iniciado com sucesso */),
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4667' /* Download APK */),
          (() => {
            if (response.apkNotFound) {
              return I18n.t('BEE4668', { 0: apkClientName } /* APK não encontrado para cliente %{0}. */);
            }
            if (response.versionTooOld) {
              return I18n.t(
                'BEE4677',
                { 0: response.minVersion }, /* Os APKs disponíveis para
                 download só estão disponíveis a partir da versão %{0} ou superior. */
              );
            }
            if (response.invalidCredentials) {
              return I18n.t('BEE4675' /* Credenciais para download do APK inválidas. */);
            }
            if (response.clientNotConfigured) {
              return I18n.t('BEE4676' /* Configure o Identificador do Cliente (APK). */);
            }
            return I18n.t('BEE4669' /* Erro ao realizar o download do APK */);
          })(),
          'top-right',
        );
      }
    } catch (e) {
      const message = e.response
        && e.response.data
        && e.response.data.error
        && e.response.data.error.message;

      addNotification(
        'danger',
        I18n.t('BEE4667' /* Download APK */),
        message || I18n.t('BEE4669' /* Erro ao realizar o download do APK */),
        'top-right',
      );
    } finally {
      this.props.removeLoading();
    }
  };

  startApkClientNameEditing = () => {
    this.setState((prevState) => ({
      apkClientNameEditing: true,
      apkClientNameOriginal: prevState.apkClientName,
    }), () => {
      if (this.apkClientNameInput) {
        this.apkClientNameInput.focus();
      }
    });
  };

  cancelApkClientNameEditing = () => {
    this.setState((prevState) => ({
      apkClientNameEditing: false,
      apkClientName: prevState.apkClientNameOriginal,
    }));
  };

  handleApkClientNameChange = (event) => {
    this.setState({
      apkClientName: event.target.value,
    });
  };

  handleApkClientNameKeyDown = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      await this.saveApkClientNameEditing();
    }
    if (event.key === 'Escape') {
      this.cancelApkClientNameEditing();
    }
  };

  createInput = (value, attr, label) => (
    <div code={attr} key={attr} className="form-group row m-b-15" style={{ height: 40 }}>
      <span className="col-form-label col-md-4">{label}</span>
      <div className="col-md-5">
        <input
          type="text"
          className="form-control m-b-5"
          value={value || '-'}
          disabled
        />
      </div>
    </div>
  );

  createApkClientNameInput = () => {
    const { apkClientName, apkClientNameEditing } = this.state;
    const label = `${I18n.t('BEE4671' /* Identificador do Cliente (APK) */)}:`;

    return (
      <div code="apkClientName" key="apkClientName" className="form-group row m-b-15" style={{ height: 40 }}>
        <span className="col-form-label col-md-4">{label}</span>
        <div className="col-md-5">
          <div className="input-group m-b-5">
            <input
              ref={(input) => { this.apkClientNameInput = input; }}
              type="text"
              className="form-control"
              value={apkClientNameEditing ? apkClientName : (apkClientName || '-')}
              disabled={!apkClientNameEditing}
              onChange={this.handleApkClientNameChange}
              onKeyDown={this.handleApkClientNameKeyDown}
            />
            <div className="input-group-append">
              {apkClientNameEditing ? (
                <>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.saveApkClientNameEditing}
                    title={I18n.t('BEE139' /* Atualizar */)}
                    aria-label={I18n.t('BEE139' /* Atualizar */)}
                  >
                    <i className="fa fa-check" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={this.cancelApkClientNameEditing}
                    title={I18n.t('BEE99' /* Cancelar */)}
                    aria-label={I18n.t('BEE99' /* Cancelar */)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.startApkClientNameEditing}
                  title={I18n.t('BEE57' /* Editar */)}
                  aria-label={I18n.t('BEE57' /* Editar */)}
                >
                  <i className="fa fa-edit" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  createQrCodeSection = () => {
    const { apkDownloadUrl, apkClientName } = this.state;

    if (!apkClientName || !apkDownloadUrl) {
      return null;
    }

    return (
      <div key="apkQrCode" className="form-group row m-b-15">
        <span className="col-form-label col-md-4">
          {I18n.t('BEE4784' /* QR Code */)}
          :
        </span>
        <div className="col-md-5">
          <div className="d-flex flex-column align-items-start">
            <ApkDownloadQrCode value={apkDownloadUrl} size={240} />
            <small className="text-muted m-t-10">
              {I18n.t(
                'BEE4783',
                /* Escaneie com o dispositivo Android para baixar o APK. O link é válido por 1 hora. */
              )}
            </small>
            <OneClickButton
              className="btn btn-default btn-sm m-t-10"
              onClick={this.loadApkDownloadQr}
            >
              <i className="fa fa-sync mr-1" />
              {I18n.t('BEE4782' /* Gerar novo QR Code */)}
            </OneClickButton>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      apkClientName,
      versionApp,
    } = this.state;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE48' /* Desenvolvedor */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4667' /* Download APK */)}</li>
          </ol>
        </div>

        <div>
          <SimpleForm
            title={I18n.t('BEE4667' /* Download APK */)}
            noButton
            inputs={[
              this.createInput(versionApp, 'versionApp', `${I18n.t('BEE4672' /* Versão do App */)}:`),
              this.createApkClientNameInput(),
              this.createQrCodeSection(),
            ].filter(Boolean)}
            footerContent={(
              <OneClickButton
                className="btn btn-primary p-5 m-5"
                disabled={!apkClientName}
                onClick={this.handleDownload}
              >
                <i className="fa fa-download mr-1" />
                {I18n.t('BEE4667' /* Download APK */)}
              </OneClickButton>
            )}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  addLoading: () => dispatch(addLoading()),
  removeLoading: () => dispatch(removeLoading()),
  getVersionApp: () => dispatch(getVersionApp()),
  updateApkClientName: (apkClientName) => dispatch(updateApkClientName(apkClientName)),
  getApkDownloadQr: () => dispatch(getApkDownloadQr()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(DevelopDownloadApk));
